import { useResendVerificationEmailMutation } from 'generated/rbi-graphql';
import { useLogger } from 'state/logger';
import { platform, welcomeEmailDomain } from 'utils/environment';

const useUserVerification = () => {
  const logger = useLogger();
  const [resendVerificationEmail, { loading }] = useResendVerificationEmailMutation();
  const sendVerificationEmail = async () => {
    try {
      await resendVerificationEmail({
        variables: {
          input: {
            stage: welcomeEmailDomain(),
            platform: platform(),
          },
        },
      });
    } catch (error) {
      logger.error({ error, message: 'Failed to resend verification link' });
    }
  };
  return {
    loading,
    sendVerificationEmail,
  };
};

export default useUserVerification;
